import { useParams } from 'react-router-dom';
import { tenantBasePath } from '../../lib/tenant.js';
import { SalesDocumentFrame } from './SalesDocumentFrame.js';

/**
 * پیش‌فاکتور — the document itself is rendered by the API
 * (`GET .../sales/quotes/:ref/document`, a standalone RTL HTML page that
 * carries the tenant logo, the Persian font and the seal/signature slots).
 * This page only frames it and offers print / save-as-HTML.
 *
 * UI_REFERENCE_SOURCE: Sakhtar Print Documents.dc.html, page 1
 *   («پیش‌فاکتور فروش») — structure follows the design; every value comes from
 *   the quote, the tenant's legal identity and the party record.
 */
export function QuotePrintPage() {
  const { slug, ref } = useParams<{ slug: string; ref: string }>();
  if (!slug || !ref) return null;
  const base = tenantBasePath(slug);
  return (
    <SalesDocumentFrame
      slug={slug}
      documentUrl={`${base}/api/v1/sales/quotes/${encodeURIComponent(ref)}/document`}
      backHref={`${base}/crm/quotes/${encodeURIComponent(ref)}`}
      backLabel="بازگشت به پیش‌فاکتور"
      frameTitle={`پیش‌فاکتور ${ref}`}
      downloadName={`proforma-${ref}.html`}
    />
  );
}
